import { gql } from '@apollo/client';
import { BASIC_POINT_FIELDS } from './point';
import {
    TASK_FIELDS_WITH_STATUS_AND_TYPE_INFO,
    TASK_FIELDS_WITH_STATUS_AND_TYPE_INFO_LIMITED
} from './task';

export const BASIC_LOCATION_FIELDS_FRAGMENT = gql`
    fragment BasicLocationFields on Location {
        Name
        LocationId
        Point {
            ...BasicPointFields
        }
    }
    ${BASIC_POINT_FIELDS}
`;

export const LOCATION_REMARK_FIELDS_FRAGMENT = gql`
    fragment LocationRemarkFields on LocationRemark {
        LocationRemarkId
        RemarkText
        Archived
        Created
        Location {
            LocationId
        }
        Updated
    }
`;

export const LOCATION_FIELDS_WITH_POINTS_AND_TASK_INFO = gql`
    fragment LocationFieldsWithPointsAndTaskInfo on Location {
        LocationId
        Name
        StartDate
        EndDate
        Point {
            ...BasicPointFields
        }
        Task {
            ...TaskFieldsWithStatusAndTypeInfo
        }
        LocationRemark {
            ...LocationRemarkFields
        }
    }
    ${BASIC_POINT_FIELDS}
    ${TASK_FIELDS_WITH_STATUS_AND_TYPE_INFO}
    ${LOCATION_REMARK_FIELDS_FRAGMENT}
`;

export const LOCATION_FIELDS_WITH_POINTS_AND_TASK_INFO_LIMITED = gql`
    fragment LocationFieldsWithPointsAndTaskInfoLimited on Location {
        LocationId
        Name
        StartDate
        EndDate
        Point {
            ...BasicPointFields
        }
        Task {
            ...TaskFieldsWithStatusAndTypeInfoLimited
        }
        LocationRemark {
            ...LocationRemarkFields
        }
    }
    ${BASIC_POINT_FIELDS}
    ${TASK_FIELDS_WITH_STATUS_AND_TYPE_INFO_LIMITED}
    ${LOCATION_REMARK_FIELDS_FRAGMENT}
`;
